import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { USAEPayAchPage } from './usaepay-ach.page';

const routes: Routes = [
  {
    path: '',
    component: USAEPayAchPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class USAEPayAchPageRoutingModule {}
